<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { userService } from '@/http'
import { useRoute } from 'vue-router'

const items = ref([])
const route = useRoute()
const isLoading = ref(false)

const fetchData = () => {
    userService.friends({}).then(res => {
        items.value = res.data
        isLoading.value = false;
    })
}

const onFriend = (id) => {
    isLoading.value = true;
    userService.like({
        id
    }).then(res => {
        console.log(res)
        fetchData()
    })
}

watch(
  () => route.query,
  async () => {
    fetchData()
  },
  {
    flush: 'post',
    immediate: true
  }
)
</script>


<style lang="scss">
.chats {
    display: flex;
    flex-direction: column;
    gap: 15px;

    &__item {
        display: flex;
        align-items: center;
        gap: 15px;
        cursor: pointer;
    }
    &__photo {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        img {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }
    &__name {
        display: flex;
        align-items: center;
        font-weight: bold;
        gap: 6px;
    }
    &__minus {
        margin-left: auto;
        background: var(--background-primary);
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        font-size: 22px;
    }
}
</style>

<template>
  <div class="chats">
    <router-link 
        v-for="item in items"
        :key="item.id"
        class="chats__item" 
        :to="{
            name: 'chat',
            params: {
                id: item.id
            }
        }"
    >
        <div class="chats__photo">
            <img 
                :src="$root.$pixel"
                v-lazy="item.photo"
                :alt="item.name"
            />
        </div>
        <div class="chats__name">{{ item.name }} <Icon name="comment" /></div>
        <button class="chats__minus" @click.prevent="onFriend(item.id)">
            <Icon name="user-minus" />
        </button>
    </router-link>
  </div>
  <Loader v-if="isLoading" />
</template>